import { ref } from "vue";
import http from "@/axios-config";

import { useCurrentMenuStore } from "../stores/current-menu";

export const menus = ref([]);

export async function createMenu(name) {
    const response = await http.post("/api/menu/create", { name: name });
    menus.value.push(response.data);
    return;
}

export async function getMenus() {
    const response = await http.get("/api/menu/index");
    menus.value = response.data;
    return;
}

export async function getMenu(slug) {
    const currentMenuStore = useCurrentMenuStore();

    currentMenuStore.food = [];
    currentMenuStore.foodTemp = [];
    currentMenuStore.drink = [];
    currentMenuStore.drinkTemp = [];

    const menuInfo = await http.get(`/api/menu/${slug}`);
    currentMenuStore.currentMenu = menuInfo.data;

    const response = await http.get(`/api/menu-items`);
    currentMenuStore.menuItems = response.data;
}

//attempts to delete menu - returns true || number of dishes still assigned
export async function deleteMenu(slug){

    const menuInfo = await http.get(`/api/menu/${slug}`);
    return menuInfo.data;

}
